import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['panel', 'maximizeButton'];

  static values = {
    valuationId: Number,
  };

  connect() {
    if (this.savedOpen) {
      this.open();
    } else {
      this.close();
    }
  }

  minimize() {
    this.close();
    this.saveState(false);
  }

  maximize() {
    this.open();
    this.saveState(true);
  }

  open() {
    this.panelTarget.classList.remove('hidden');
    if (this.hasMaximizeButtonTarget) {
      this.maximizeButtonTarget.classList.add('hidden');
    }
  }

  close() {
    this.panelTarget.classList.add('hidden');
    if (this.hasMaximizeButtonTarget) {
      this.maximizeButtonTarget.classList.remove('hidden');
    }
  }

  get storageKey() {
    if (!this.hasValuationIdValue) return null;

    return `valuation-details-drawer-open-${this.valuationIdValue}`;
  }

  get savedOpen() {
    if (!this.storageKey) return false;

    try {
      return localStorage.getItem(this.storageKey) === 'true';
    } catch (e) {
      console.warn('Could not restore drawer state:', e);
      return false;
    }
  }

  saveState(open) {
    if (!this.storageKey) return;

    try {
      localStorage.setItem(this.storageKey, String(open));
    } catch (e) {
      console.warn('Could not save drawer state:', e);
    }
  }
}
